<template>
  <section class="about">
    <div class="container">
      <h2 class="section-heading">About</h2>
      <div class="content">
        <p>
          I am Shahab Malik , a passionate web developer having 2+ years of
          experience in web development. I am doing Bsc. Software Engineering
          from UET,Taxila Pakistan. I have developed a number of websites for
          many business startups. I have worked with clients globally and have
          provided products more than their expectations. <br /><br />
          I love coding and keep myself updated by learning new Technologies. I
          build user firendly products by taking in point of view principles of
          UI/UX. My first priority is customer staisfaction.

          <br /><br />
          Let us Work together.
        </p>
      </div>

      <div class="btn-container">
        <button class="btn-secondary" @click="openForm">
          Contact Me
        </button>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    methods:{
      openForm() {
        this.$store.dispatch("openContact");
      },
      closeForm() {
        this.$store.dispatch("closeContact");
      },
    }
  };
</script>

<style scoped>
  .about {
    padding-top: 60px;
  }

  .content {
    width: 60%;
    margin: 0 auto;
    color: var(--color-primary);
    line-height: 175%;
    font-size: 1.2em;
  }
  .btn-container{
  display: flex;
  justify-content: center;
  margin-top:30px ;
}

@media only screen and (max-width:767px){
.content{
  width: 100%;
  line-height: 160%;
}

}
@media only screen and (max-width:767px){
.btn-container{
  margin-top: 20px;
}
}

</style>
